// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__rnKUc","ant-page-header-heading-title":"styles_ant-page-header-heading-title__Zaq8u","table":"styles_table__FVXtU"};